import React from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import InvoiceList from "./InvoiceList";

export default function () {
    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{display: "flex"}}
            >
                <div
                    style={{
                        margin: "8px 20px"
                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <InvoiceList/>
            </Card>
        </>
    )
}